<template>
    <v-footer app class="notification-footer pa-0" v-if="isAppLoaded && shouldShowFooter">
        <CookiesNotification
            v-if="showCookiesNotification"
            @cookies-agreement="showCookiesNotification = false"
        />
    </v-footer>
</template>
<script>
import CookiesNotification from '@/components/banner/CookiesNotificationBanner'
import CookiesAgreement    from '@/models/CookiesAgreement'
import { mapGetters }      from 'vuex'

export default {
    name: 'NotificationFooter',
    components: { CookiesNotification },
    data: vm => ({
        showCookiesNotification: false,
    }),
    methods: {
        checkForCookies() {
            // Verifica se o usuario tem cookies aceitos na camada de persistência
            let cookiesAgreement = new CookiesAgreement()
            let cookies          = cookiesAgreement.getFromPersistence()

            this.showCookiesNotification = !cookies
        },
    },
    computed: {
        shouldShowFooter() {
            // Adicionar outros
            return this.showCookiesNotification
        },
        ...mapGetters({
            isAppLoaded: 'app/isLoaded',
        }),
    },
    watch: {
        isAppLoaded(v) {
            // Assim que a app carregar verifica se tem cookies
            if (v) {
                this.checkForCookies()
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.notification-footer {
    z-index: 99;
}
</style>